import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthConsumer } from './authprovider';

export const PrivateRoute = ({ component: Component }) => {
  return (
    <AuthConsumer>
      {({ isAuthenticated, signinRedirect }) => {
        if (!!Component && isAuthenticated()) {
          return <Component />;
        } else {
          signinRedirect();
          return <Navigate to="/external/signin" replace />;
        }
      }}
    </AuthConsumer>
  );
};
